import React from 'react';

interface ThumbnailProps {
  link?: { href: string; text: string };
  img: string;
}

const ThumbnailItem = ({ link, img }: ThumbnailProps) => {
  return (
    <a
      href={link?.href}
      className="flex min-w-[150px] max-w-[150px] flex-col items-center gap-2 lg:max-w-none"
    >
      <img src={img} className="aspect-square w-full object-cover" />
      <span className="text-lg font-bold">{link?.text}</span>
    </a>
  );
};

export default ThumbnailItem;
